import { Dialog, DialogContent, Grid } from "@mui/material";
import React, { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { Wizard } from "../../../../../Component/Common/Components/Wizard/Wizard";
import { AncillaryCost } from "../../../../../Component/Model/Dto/WSP/AncillaryCost";
import { defaultObject } from "../../../../../Helpers/typescriptHelper";
import { OrganisationAtom } from "../../../../../State/Organisation.Atom";
import { AncillaryCostAttendeeModal } from "./AncillaryCostAttendeeModal";
import { AncillaryCostDescription } from "./AncillaryCostDescription";
import { CustomDialogTitle } from "../../../../Common/Custom/CustomDialogTitle";

interface IProps {
  interventionTypeId: number,
  selectedInterventionId: number,
  ancillaryCost?: AncillaryCost,
  openAssociateAttendee?: boolean,
  openWithNoBackOption?: boolean,
  open: boolean,
  closeModal: () => void
}

export const AncillaryCostModal = ({ open, closeModal, ancillaryCost: ancillaryCost, selectedInterventionId: selectedInterventionId, interventionTypeId: interventionTypeId, openAssociateAttendee: openAssociatedAttendee }: IProps) => {
  const stepLabels = ['Details', 'Associate Attendees'];
  const [initialStep, setInitialStep] = React.useState<number>(0);
  const [handleNextCount, setHandleNextCount] = React.useState<number>(-1);
  const [ancillaryCostData, setAncillaryCostData] = React.useState<AncillaryCost>(ancillaryCost ? ancillaryCost : defaultObject);

  const peopleAndTrainingOrganisation = useRecoilValue(OrganisationAtom);

  useEffect(() => {
    if (openAssociatedAttendee) {
      setHandleNextCount(0);
      setInitialStep(1);
    }
  }, [openAssociatedAttendee]);

  const closeAncillaryCostModal = async () => {
    closeModal();
  }
  const setAncillaryCostDataAfterCreate = async (ancillaryCost: AncillaryCost) => {
    setAncillaryCostData(ancillaryCost);
  }

  const detailsStep = () => (
    <AncillaryCostDescription
      interventionTypeId={interventionTypeId}
      selectedInterventionId={selectedInterventionId}
      ancillaryCost={ancillaryCostData}
      closeModal={closeAncillaryCostModal}
      handleNextCount={handleNextCount}
      setHandleNextCount={setHandleNextCount}
      setAncillaryCostDataAfterCreate={setAncillaryCostDataAfterCreate} />);

  const attendeesStep = () => (
    <AncillaryCostAttendeeModal
      interventionTypeId={interventionTypeId}
      organisationId={peopleAndTrainingOrganisation.OrganisationId.toString()}
      ancillaryCostId={+ancillaryCostData.id!}
      closeModal={closeAncillaryCostModal}
      interventionId={selectedInterventionId}
      handleNextCount={handleNextCount}
      setHandleNextCount={setHandleNextCount} />);

  const wizardSteps = [
    detailsStep(),
    attendeesStep()
  ];

  return (
    <Dialog open={open} onClose={() => closeAncillaryCostModal()} aria-labelledby="form-dialog-title" maxWidth="lg">
      <CustomDialogTitle id="customized-dialog-title" onClose={() => closeAncillaryCostModal()}>
        Capture Ancillary Cost
      </CustomDialogTitle>
      <DialogContent style={{ borderBottom: 0, paddingBottom: 0 }}>
        <Grid minWidth={"850px"} pt={4}>
          <Grid item xs={12}>
            <Wizard key={'AncillaryCostWizard'} handleNext={true} handleNextCount={handleNextCount} stepLabels={stepLabels} steps={wizardSteps} lastStepActionLabel={''} removeShadow initialStep={initialStep} />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

